// @generated by protoc-gen-es v2.16.0 with parameter "target=js+dts"
// @generated from file hello.proto (package hello, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";

/**
 * Describes the file hello.proto.
 */
export const file_hello = /*@__PURE__*/
  fileDesc("CgtoZWxsby5wcm90bxIFaGVsbG8iHAoMSGVsbG9SZXF1ZXN0EgwKBG5hbWUYASABKAkiIAoNSGVsbG9SZXNwb25zZRIPCgdtZXNzYWdlGAEgASgJMkcKDEhlbGxvU2VydmljZRI3CghTYXlIZWxsbxITLmhlbGxvLkhlbGxvUmVxdWVzdBoULmhlbGxvLkhlbGxvUmVzcG9uc2UiAEIqWihnaXRodWIuY29tL21heWJlY2FrZS9zdGFja3MvZ2VuL2dvO2hlbGxvYgZwcm90bzM");

/**
 * Describes the message hello.HelloRequest.
 * Use `create(HelloRequestSchema)` to create a new message.
 */
export const HelloRequestSchema = /*@__PURE__*/
  messageDesc(file_hello, 0);

/**
 * Describes the message hello.HelloResponse.
 * Use `create(HelloResponseSchema)` to create a new message.
 */
export const HelloResponseSchema = /*@__PURE__*/
  messageDesc(file_hello, 1);

/**
 * @generated from service hello.HelloService
 */
export const HelloService = /*@__PURE__*/
  serviceDesc(file_hello, 0);

